module.exports = __webpack_public_path__ + "bz.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/4x3/bz.svg
// module id = 475
// module chunks = 0